import { Outlet } from 'react-router-dom';
import { DevToolsPanel } from '@/features/dev-tools';
import { VersionUpdateBanner } from '@/features/version-skew';
import { BuildIdLabel } from '@/components/BuildIdLabel';
import { useStationMode } from '@/hooks/use-role';

export function ProductionLayout() {
  // The same stationMode AppLayout uses to decide whether AppSidebar renders.
  // The build-id badge below is a fixed-position overlay meant for a
  // sidebar-free surface, so it follows that answer rather than assume every
  // ProductionLayout route is chrome-free.
  const stationMode = useStationMode();

  return (
    <div className="production-workspace flex flex-col flex-1">
      <VersionUpdateBanner />
      {/* A full-viewport child (the Client messages inbox) opts out of the 48px bottom padding. */}
      <main className="flex-1 pb-12 has-[[data-fills-viewport]]:pb-0">
        <Outlet />
      </main>
      <DevToolsPanel />
      {/* Pinned top-right so it never collides with the bottom-anchored scan
          bars/action bars most stations use, or with DevToolsPanel (fixed
          bottom, z-40). pointer-events-none is mandatory: a scanner-first
          station must never gain an invisible click target. z-20 keeps it
          above base content (z-0), below the version-skew banner (sticky
          z-30) and every modal. No mute/volume icon occupies this corner
          today (PRODUCTION_DESIGN §"Mute" describes one as future work) —
          revisit the offset if that ships. */}
      {stationMode && (
        <BuildIdLabel
          variant="station"
          className="fixed top-1 right-2 z-20 pointer-events-none"
        />
      )}
    </div>
  );
}
